import { FC, ReactNode } from "react";
import {
  Box,
  CircularProgress,
  createStyles,
  makeStyles,
  Typography,
  useMediaQuery,
} from "@material-ui/core";

import theme from "theme";

export interface StatProps {
  label: string;
  value?: string | ReactNode;
  valueAdornment?: ReactNode;
  pr?: number;
  isLoading?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    mobileContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  }),
);

const Stat: FC<StatProps> = ({
  isLoading,
  label,
  value,
  valueAdornment,
  pr = 0,
}) => {
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Box pr={pr} className={isMobile ? classes.mobileContainer : ""}>
      <Box height={32} display="flex" alignItems="center">
        {isLoading ? (
          <CircularProgress size={30} />
        ) : (
          <>
            <Typography variant="body2" component="div">
              <Box fontWeight={theme.typography.fontWeightMedium}>{label}</Box>
            </Typography>
            {valueAdornment}
          </>
        )}
      </Box>
      <Typography variant="h5" component="div">
        <Box fontWeight="fontWeightLight">{value}</Box>
      </Typography>
    </Box>
  );
};

export default Stat;
